/* eslint-disable */

//
// A lightly-altered implemetation of the array.js in Observable inspector implementation:
// https://github.com/observablehq/inspector/blob/e88c0459a71f9bcfd8c22b8c78262f71979821b2/src/array.js
//

export type Arrayish<T> =
	| Array<T>
	| Int8Array
	| Int16Array
	| Int32Array
	| Uint8Array
	| Uint8ClampedArray
	| Uint16Array
	| Uint32Array
	| Float32Array
	| Float64Array;

/**
 * Returns true if an object is `Arrayish`.
 */
export function isarray<T>(value: any): value is Arrayish<T> {
	// NOTE: This is unlike the Chrome and Firefox consoles, which test based on whether `slice` and
	// `length` are members, for JQuery-related reasons. See:
	// https://twitter.com/mbostock/status/702737065121742848

	return (
		Array.isArray(value) ||
		value instanceof Int8Array ||
		value instanceof Int16Array ||
		value instanceof Int32Array ||
		value instanceof Uint8Array ||
		value instanceof Uint8ClampedArray ||
		value instanceof Uint16Array ||
		value instanceof Uint32Array ||
		value instanceof Float32Array ||
		value instanceof Float64Array
	);
}

/**
 * Checks if an object key is an array index. Explicitly rejects non-integer keys, e.g., the `0.5`
 * in `[1, 2, 0.5: "value"]`.
 */
export function isindex(key: any): boolean {
	// This type coercion magic is meant to explicitly reject non-integer keys, e.g., `0.5` in `[1,
	// 2, 0.5: "value"]`. Taken directly from Observable's inspector implementation.
	return key === (key | 0) + "";
}
